export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13993.e60c2bb0.jpg";